var SpriteSheetAnimationFrame = (function () {
    function SpriteSheetAnimationFrame() {
    }
    return SpriteSheetAnimationFrame;
}());
export { SpriteSheetAnimationFrame };
